export default {
  "app_label": "jobs",
  "model_name": "tag",
  "pagination": true,
  "columns": [
    {
      "name": "pk",
      "label": "ID",
      "help_text": null,
      "hidden": true,
      "identifier": true,
      "data_type": "int",
      "search": false,
      "sort": false
    },
    {
      "name": "code",
      "label": "Code",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "search": true,
      "sort": true
    },
    {
      "name": "name",
      "label": "Name",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "search": true,
      "sort": true
    },
    {
      "name": "excerpt",
      "label": "Excerpt",
      alias_order: "content",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "search": false,
      "sort": true
    },
    {
      "name": "modified",
      "label": "Modified",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "datetime",
      "search": false,
      "sort": true
    }
  ],
  "filter_by": [
    {
      "label": "Show in csv",
      "name": "show_in_csv",
      "type": "switch"
    },
    {
      "label": "Show in pdf",
      "name": "show_in_pdf",
      "type": "switch"
    }
  ],
  "export_import": null
}